<ng-template #templateSubstitute>
  <span class="d-flex icon material-symbols-outlined m-r-4"> find_replace </span>

  {{ 'productRow.actions.viewReplacement' | cxTranslate }}
</ng-template>

@if (product.substituteProduct) {
  <a tabindex="0" [routerLink]="['/p/' + product.substituteProduct]" class="btn btn-primary w-100">
    <ng-container *ngTemplateOutlet="templateSubstitute"> </ng-container>
  </a>
} @else {
  <a tabindex="0" [routerLink]="['/product-cross-reference']" [queryParams]="{ code: product.partNumber }" class="btn btn-primary w-100">
    <ng-container *ngTemplateOutlet="templateSubstitute"> </ng-container>
  </a>
}
